module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-8.7723d482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-8.jpg
// module id = 1894
// module chunks = 2